import { orderBy, uniqBy } from 'lodash';
import ChatGroup, { ChatGroupId } from '@/chat/models/ChatGroup';
import { DEFAULT_LANGUAGE } from '@/shared/constants/Language';
import VehicleType from '@/shared/constants/VehicleType';
import Brand, { BrandId } from '@/shared/models/Brand';
import { CountryId } from '@/shared/models/Country';
import Outlet, { OutletId } from '@/shared/models/Outlet';
import User from '@/shared/models/User';
import { DealerGroupId } from '@/shared/models/common';
import { isPresent, present } from '@/shared/utils/typescript';
import { WorkPreparationRoleId } from '@/workPreparation/models/WorkPreparationRole';
import { RoleId } from './Role';
import WorkshopTeam, { WorkshopTeamId } from './WorkshopTeam';

export default class Identity extends User {
  dealerGroupId: DealerGroupId | null = null;
  countryId: CountryId | null = null;
  language = DEFAULT_LANGUAGE;
  vehicleType!: VehicleType;
  roleIds: Array<RoleId> = [];
  hasSignature = false;
  mainOutletId: OutletId | null = null;
  outlets: Array<Outlet> = [];
  brands: Array<Brand> = [];
  workshopTeams: Array<WorkshopTeam> = [];
  groups: Array<ChatGroup> = [];
  workPreparationRoleId: WorkPreparationRoleId | null = null;
  hasDBBCredentials = false;

  getOutlet(outletId: OutletId): Outlet {
    return present(this.outlets.find(o => o.id === outletId));
  }

  getBrand(brandId: BrandId): Brand {
    return present(this.brands.find(b => b.id === brandId));
  }

  getTeam(teamId: WorkshopTeamId): WorkshopTeam {
    return present(this.workshopTeams.find(t => t.id === teamId));
  }

  getAvailableBrands(outletIds: Array<OutletId>): Array<Brand> {
    const filtered = outletIds.length === 0 ? this.brands : this.brands.filter(b => isPresent(b.outletId) && outletIds.includes(b.outletId));
    const unique = uniqBy(filtered, 'id');
    return orderBy(unique, 'description');
  }

  getAvailableTeams(outletIds: Array<OutletId>): Array<WorkshopTeam> {
    if (outletIds.length !== 1) return [];
    const filtered = this.workshopTeams.filter(t => outletIds.includes(t.outletId));
    return orderBy(filtered, 'description');
  }

  isValidTeam(outletId: OutletId, teamId: WorkshopTeamId): boolean {
    return this.workshopTeams.some(t => t.id === teamId && t.outletId === outletId);
  }

  isMemberOfGroup(groupId: ChatGroupId): boolean {
    return this.groups.some(g => g.id === groupId);
  }
}
